import { Component, OnInit } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { ConfigService } from './utils/config-service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private translate: TranslateService, private configService: ConfigService) {
    translate.addLangs(['nl', 'en', 'fr', 'es']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit() {
    if (!this.configService.isValidConfig()) {
      console.log('No Valid ConfigurationFile Found');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts